<template>
  <div class="entrustChild">
    <div class="banner">
      <div class="toinfo">
        <span @click="toinfo">托管说明</span>
        <img class="zhuyi" src="./img/zhuyi.png" alt="" />
      </div>
      <img class="bannerImg" src="./img/banner.png" alt="" />
    </div>
    <div class="title">
      <div class="title-l" @click="handelSelectType">
        <div class="type">{{ type == 1 ? "按课程预约" : "按时段预约" }}</div>
        <div class="drawJt"></div>
      </div>
      <div class="title-r" @click="myAppoint">
        <div class="txt">我的预约</div>
        <div class="img"><img src="./img/arrow.png" alt="" /></div>
      </div>
    </div>
    <!-- 开放日期 -->
    <div class="time" ref="time">
      <div
        v-for="(item, index) in timeList"
        :key="index"
        :class="['item', { active: index == oIndex }]"
        @click="selectTime(item, index)"
      >
        <div class="item-t">{{ item.key }}</div>
        <div class="item-b">{{ item.value }}</div>
      </div>
    </div>
    <div class="main">
      <!-- 课程预约start -->
      <div class="main-t" v-if="type == 1">
        <div class="item" v-if="amList.length != 0">
          <div class="item-l">
            <div>
              <p>上</p>
              <p>午</p>
            </div>
          </div>
          <div class="item-c">
            <div
              class="list"
              v-for="(item, index) in postData"
              :key="index"
              v-show="item.timeDuring == '上午'"
            >
              <div class="list-l">
                <div class="list-l-c">
                  <p>{{ item.activityName }}</p>
                  <h3>
                    {{ `${item.activityBeginTime}~${item.activityEndTime}` }}
                  </h3>
                </div>
              </div>
              <div class="list-r">{{ item.activityDetail }}</div>
            </div>
          </div>
          <div class="item-r">
            <div class="item-r-c">
              <div class="btn">
                <div class="btn-r">
                  <div
                    :class="[
                      'opera1',
                      {
                        full:
                          amList[0].applicantsNum == amList[0].applicantsMax,
                      },
                    ]"
                    @click="toAppoint(amList[0].scheduleId)"
                    v-if="amList[amList.length - 1].orderStatus == '预约'"
                  >
                    预约
                  </div>
                  <div
                    class="opera1 full"
                    v-if="amList[amList.length - 1].orderStatus == '不可预约'"
                  >
                    已过期
                  </div>
                  <div
                    class="opera1 full"
                    v-if="amList[amList.length - 1].orderStatus == '已约满'"
                  >
                    已约满
                  </div>
                  <div
                    class="opera2"
                    v-if="amList[amList.length - 1].orderStatus == '待审核'"
                  >
                    待审核
                  </div>
                  <div
                    class="opera2"
                    v-if="amList[amList.length - 1].orderStatus == '审核失败'"
                  >
                    审核失败
                  </div>
                  <div
                    class="opera3"
                    v-if="amList[amList.length - 1].orderStatus == '查看视频'"
                    @click="toLook(amList[0].scheduleId)"
                  >
                    查看视频
                  </div>
                  <div
                    class="opera3"
                    v-if="amList[amList.length - 1].orderStatus == '待开始'"
                  >
                    待开始
                  </div>
                  <div
                    v-if="amList[amList.length - 1].orderStatus == '评价'"
                    class="opera1"
                    @click="evaluate(amList[0].scheduleId)"
                  >
                    评价
                  </div>
                  <div
                    class="opera3"
                    v-if="amList[amList.length - 1].orderStatus == '已评价'"
                  >
                    已评价
                  </div>
                </div>
              </div>
              <div class="txt">
                <div class="txt-c">
                  已预约{{ amList[0].applicantsNum }}/{{
                    amList[0].applicantsMax
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item" v-if="pmList.length != 0">
          <div class="item-l">
            <div>
              <p>下</p>
              <p>午</p>
            </div>
          </div>
          <div class="item-c">
            <div
              class="list"
              v-for="(item, index) in postData"
              :key="index"
              v-show="item.timeDuring == '下午'"
            >
              <div class="list-l">
                <div class="list-l-c">
                  <p>{{ item.activityName }}</p>
                  <h3>
                    {{ `${item.activityBeginTime}~${item.activityEndTime}` }}
                  </h3>
                </div>
              </div>
              <div class="list-r">{{ item.activityDetail }}</div>
            </div>
          </div>
          <div class="item-r">
            <div class="item-r-c">
              <div class="btn">
                <!-- <div class="btn-l">预约结束</div> -->
                <div class="btn-r">
                  <div
                    :class="[
                      'opera1',
                      {
                        full:
                          pmList[0].applicantsNum == pmList[0].applicantsMax,
                      },
                    ]"
                    @click="toAppoint(pmList[0].scheduleId)"
                    v-if="pmList[pmList.length - 1].orderStatus == '预约'"
                  >
                    预约
                  </div>
                  <div
                    class="opera1 full"
                    v-if="pmList[pmList.length - 1].orderStatus == '不可预约'"
                  >
                    已过期
                  </div>
                  <div
                    class="opera1 full"
                    v-if="pmList[pmList.length - 1].orderStatus == '已约满'"
                  >
                    已约满
                  </div>

                  <div
                    class="opera2"
                    v-if="pmList[pmList.length - 1].orderStatus == '待审核'"
                  >
                    待审核
                  </div>
                  <div
                    class="opera2"
                    v-if="pmList[pmList.length - 1].orderStatus == '审核失败'"
                  >
                    审核失败
                  </div>
                  <div
                    class="opera3"
                    v-if="pmList[pmList.length - 1].orderStatus == '查看视频'"
                    @click="toLook(pmList[0].scheduleId)"
                  >
                    查看视频
                  </div>
                  <div
                    class="opera3"
                    v-if="pmList[pmList.length - 1].orderStatus == '待开始'"
                  >
                    待开始
                  </div>

                  <div
                    class="opera1"
                    v-if="pmList[pmList.length - 1].orderStatus == '评价'"
                    @click="evaluate(pmList[pmList.length - 1].scheduleId)"
                  >
                    评价
                  </div>
                  <div
                    class="opera3"
                    v-if="pmList[pmList.length - 1].orderStatus == '已评价'"
                  >
                    已评价
                  </div>
                </div>
              </div>
              <div class="txt">
                <div class="txt-c">
                  已预约{{ pmList[0].applicantsNum }}/{{
                    pmList[0].applicantsMax
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 课程预约end -->
      <!-- 托幼预约start  -->
      <div class="Kindergartens" v-else>
        <div
          class="item"
          v-if="kindData && kindData.voList && kindData.voList.length != 0"
        >
          <div class="item-c">
            <div
              class="list"
              v-for="(item, index) in kindData.voList"
              :key="index"
            >
              <div class="list-l">
                <div class="list-l-c">
                  <h3>
                    {{ `${item.beginTime}~${item.endTime}` }}
                  </h3>
                </div>
              </div>

              <div class="list-r">
                <div class="item-r-c">
                  <div class="btn">
                    <div class="btn-r">
                      <div
                        :class="[
                          'opera1',
                          {
                            full: item.applicantsNum == item.applicantsMax,
                          },
                        ]"
                        @click="toAppoint(kindData.scheduleId, item.detailId)"
                        v-if="item.orderStatus == '预约'"
                      >
                        预约
                      </div>
                      <div
                        class="opera1 full"
                        v-if="item.orderStatus == '不可预约'"
                      >
                        已过期
                      </div>
                      <div
                        class="opera1 full"
                        v-if="item.orderStatus == '已约满'"
                      >
                        已约满
                      </div>
                      <div class="opera2" v-if="item.orderStatus == '待审核'">
                        待审核
                      </div>
                      <div class="opera2" v-if="item.orderStatus == '审核失败'">
                        审核失败
                      </div>
                      <div
                        class="opera3"
                        v-if="item.orderStatus == '查看视频'"
                        @click="toLook(kindData.scheduleId, item.detailId)"
                      >
                        查看视频
                      </div>
                      <div class="opera3" v-if="item.orderStatus == '待开始'">
                        待开始
                      </div>
                      <div
                        class="opera1"
                        v-if="item.orderStatus == '评价'"
                        @click="evaluate(kindData.scheduleId, item.detailId)"
                      >
                        评价
                      </div>
                      <div class="opera3" v-if="item.orderStatus == '已评价'">
                        已评价
                      </div>
                    </div>
                  </div>
                  <div class="txt">
                    <div class="txt-c">
                      已预约{{ item.applicantsNum }}/{{ item.applicantsMax }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 托幼预约start  -->
      <v-empty
        description="当日无课程安排"
        v-if="type == 1 && amList.length == 0 && pmList.length == 0"
      ></v-empty>
      <v-empty
        description="当日无课程安排"
        v-if="type == 2 && Object.keys(kindData).length == 0"
      ></v-empty>
    </div>
    <div class="evaluateDialog" v-if="isShowEvaluate">
      <div class="dialogMain">
        <div class="mainBody">
          <div class="mainTitle">请为本次托幼活动打分（必填）</div>
          <div class="mainScore">
            <div class="rate" v-for="i in 5" :key="i">
              <div class="rateIcon">
                <img
                  @click="form.grade = i"
                  :src="
                    require(form.grade >= i
                      ? './img/starSelect.png'
                      : './img/star.png')
                  "
                  alt=""
                />
              </div>
              <div class="rateTxt">{{ scoreMap[i] }}</div>
            </div>
          </div>
          <div class="mainUpload">
            <v-upload
              class="oItem-b_upload"
              :imgUrl.sync="form.feedbackPicture"
              :activityPicture.sync="form.feedbackPicture"
              :maxCount="6"
              ref="load"
            ></v-upload>
            <div class="txt">最多可上传6张照片</div>
          </div>
          <div class="mainInput">
            <v-input
              v-model="form.feedbacksSuggestion"
              placeholder="评价理由"
              type="textarea"
              :maxlength="30"
              :showWordLimit="true"
            ></v-input>
          </div>
          <div class="submitBtn">
            <div class="btn" @click="evaluateSubmit">提交</div>
          </div>
        </div>
        <div class="mainClose" @click="evaluateClose">
          <img src="./img/close.png" alt="" />
        </div>
      </div>
    </div>
    <v-picker
      :columns="typeList"
      :defaultIndex="defaultIndex"
      :valueShow="isShowType"
      valueKey="label"
      @clickOverlay="clickOverlay"
      @cancel="cancelPick"
      @confirmPicker="confirm"
    ></v-picker>
  </div>
</template>

<script>
import { weekArrMap, weekListMap } from "./map.js";
import { getClassDataByDayUrl, appraiseUrl } from "./api.js";
import { gloabalCount, toRegister } from "@/utils/common";
var moment = require("moment");
export default {
  name: "entrustChild",
  data() {
    return {
      oIndex: 14,
      postData: [],
      kindData: {}, //托幼数据
      amList: [],
      pmList: [],
      timeList: [],
      scheduleId: "",
      isShowEvaluate: false,
      indexTime: moment(new Date()).format("YYYY-MM-DD"),
      /* dialog */
      form: {
        grade: undefined,
        feedbackPicture: "",
        feedbacksSuggestion: "",
      },
      scoreMap: {
        1: "非常差",
        2: "差",
        3: "一般",
        4: "满意",
        5: "非常满意",
      },
      isShowType: false,
      typeList: [
        {
          type: 1,
          label: "按课程预约",
        },
        {
          type: 2,
          label: "按时段预约",
        },
      ],
      type: 1,
      detailId: "", //场次
      defaultIndex: 0, // picker默认选择展示
    };
  },
  computed: {
    communityId() {
      return this.$store.state.communityId;
    },
    userId() {
      return this.$store.state.userId;
    },
    roomId() {
      return this.$store.state.houseId;
    },
    tenantId() {
      return this.$store.state.tenantId;
    },
  },
  async created() {
    if (localStorage.getItem("appointmentType")) {
      const result = JSON.parse(localStorage.getItem("appointmentType"));
      const { type, oIndex } = result;
      type == 1 ? (this.defaultIndex = 0) : (this.defaultIndex = 1);
      this.type = type;
      this.oIndex = oIndex;
    }
    this.getTimeList();
    if (this.type == 1) {
      this.getPartyList(this.timeList[this.oIndex].goal);
    } else {
      this.getKindList(
        this.timeList[this.oIndex].goal,
        weekListMap[this.timeList[this.oIndex].key]
      );
    }
    // if (await toRegister(this.$route.path, this.$route.query, "场馆预约")) {
    // }
  },
  mounted() {
    gloabalCount("", 57, 1);
    if (this.$refs.time && document.querySelector(".active")) {
      this.$refs.time.scrollTo(
        document.querySelector(".active").offsetLeft * 0.835,
        0
      );
    }
  },
  methods: {
    toinfo() {
      this.$router.push({
        name: "entrustChildInfo",
      });
    },
    //选择方式确定
    confirm(item) {
      item.type == 1 ? (this.defaultIndex = 0) : (this.defaultIndex = 1);
      this.type = item.type;
      this.storageAppointment();
      if (this.type == 1) {
        this.getPartyList(this.timeList[this.oIndex].goal);
      } else {
        this.getKindList(
          this.timeList[this.oIndex].goal,
          weekListMap[this.timeList[this.oIndex].key]
        );
      }
      this.isShowType = false;
    },
    cancelPick() {
      this.isShowType = false;
    },
    clickOverlay() {
      this.isShowType = false;
    },
    //选择预约方式
    handelSelectType() {
      this.isShowType = true;
    },
    // 我的预约
    myAppoint() {
      this.storageAppointment();
      this.$router.push({
        name: "myEntrustChild",
        query: {
          type: this.type,
        },
      });
    },
    // 选择日期
    selectTime(item, index) {
      this.oIndex = index;
      this.postData = [];
      this.kindData = {};
      this.amList = [];
      this.pmList = [];
      if (this.type == 1) {
        this.getPartyList(item.goal);
      } else {
        this.getKindList(item.goal, weekListMap[item.key]);
      }
    },
    // 查看视频
    toLook(scheduleId, detailid) {
      this.storageAppointment();
      this.$router.push({
        name: "entrustChildVideo",
        query: {
          scheduleId: scheduleId,
          detailid: detailid,
        },
      });
    },
    // 评价
    evaluate(scheduleId, detailId) {
      this.storageAppointment();
      this.scheduleId = scheduleId;
      if (detailId) {
        this.detailId = detailId;
      }
      this.isShowEvaluate = true;
    },
    // 去预约
    toAppoint(scheduleId, detailId) {
      this.storageAppointment();
      this.$router.push({
        name: "entrustChildList",
        query: {
          scheduleId: scheduleId,
          type: this.type,
          oIndex: this.oIndex,
          detailId,
          dayName: this.timeList[this.oIndex].goal,
        },
      });
    },
    // 缓存预约方式以及当前日期下标位置
    storageAppointment() {
      let params = {
        type: this.type,
        oIndex: this.oIndex,
      };
      localStorage.setItem("appointmentType", JSON.stringify(params));
    },
    // 关闭评价弹框
    evaluateClose() {
      console.log(JSON.stringify(this.form), "--this.form");
      this.isShowEvaluate = false;
      this.form = {
        grade: undefined,
        feedbackPicture: "",
        feedbacksSuggestion: "",
      };
    },
    /* 辅助方法 */
    // 返回固定格式的时间
    returnTime(data) {
      if (data) {
        return moment(data).format("YYYY-MM-DD");
      }
    },
    // 获取前后15天内的日期信息
    getTimeList() {
      const timeList = [];
      let num = 15;
      // 往前15天
      for (let i = 1; i < num; i++) {
        let obj = {
          key: weekArrMap[
            moment(new Date())
              .subtract(num - i, "days")
              .weekday()
          ],
          value: moment(new Date())
            .subtract(num - i, "days")
            .format("MM.DD"),
          goal: moment(new Date())
            .subtract(num - i, "days")
            .format("YYYY-MM-DD"),
        };
        timeList.push(obj);
      }
      // 往后15天
      for (let i = 0; i < num; i++) {
        let obj = {
          key: weekArrMap[moment(new Date()).add(i, "days").weekday()],
          value: moment(new Date()).add(i, "days").format("MM.DD"),
          goal: moment(new Date()).add(i, "days").format("YYYY-MM-DD"),
        };
        timeList.push(obj);
      }
      this.timeList = timeList;
      console.log(this.timeList);
    },
    /* 接口 */
    // 查询对应日期的课程
    async getPartyList(dayData) {
      let params = {
        tenantId: this.tenantId,
        houseId: this.roomId || this.communityId || undefined,
        userId: this.userId,
        dayData,
        type: 1,
      };
      this.amList = [];
      this.pmList = [];
      let res = await this.$axios.get(getClassDataByDayUrl, { params });
      if (res.code === 200) {
        this.postData = res.data;
        this.postData.forEach((ele) => {
          if (ele.timeDuring == "上午") {
            this.amList.push(ele);
          }
          if (ele.timeDuring == "下午") {
            this.pmList.push(ele);
          }
        });
      }
    },
    // 查询托幼预约接口
    async getKindList(dayData, weekName) {
      let params = {
        tenantId: this.tenantId,
        houseId: this.roomId || this.communityId || undefined,
        userId: this.userId,
        type: 2,
        dayData,
        weekName,
      };
      let res = await this.$axios.get(getClassDataByDayUrl, { params });
      if (res.code === 200) {
        if (res.data?.voList) {
          this.kindData = res.data;
        }
      }
    },
    // 提交评价内容
    async evaluateSubmit() {
      if (!this.form.grade) {
        this.$toast({ message: "请先打分！", duration: 2000 });
        return;
      }
      let params;
      if (this.type === 1) {
        params = {
          userId: this.userId,
          scheduleId: this.scheduleId,
          orderStatus: "已评价",
          ...this.form,
        };
      } else {
        params = {
          userId: this.userId,
          scheduleId: this.scheduleId,
          orderStatus: "已评价",
          detailId: this.detailId,
          ...this.form,
        };
      }
      let res = await this.$axios.post(appraiseUrl, params);

      if (res.code === 200) {
        // 关闭评价弹框
        this.evaluateClose();
        if (this.type == 1) {
          this.getPartyList(this.timeList[this.oIndex].goal);
        } else {
          this.getKindList(
            this.timeList[this.oIndex].goal,
            weekListMap[this.timeList[this.oIndex].key]
          );
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.entrustChild {
  height: 100vh;
  .banner {
    height: 319px;
    position: relative;
    .toinfo {
      display: flex;
      align-items: center;
      position: absolute;
      top: 30px;
      left: 38px;
      span {
        font-size: 30px;
        color: rgba(0, 125, 242, 1);
        margin-right: 10px;
      }
      img {
        width: 30px;
        height: 30px;
      }
    }

    .bannerImg {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    padding: 32px;
    display: flex;
    justify-content: space-between;
    .title-l {
      display: flex;
      align-items: center;
      width: 250px;
      height: 50px;
      line-height: 50px;
      position: relative;
      border: 2px solid #c2c0c0;
      border-radius: 8px;
      text-align: left;
      padding-left: 10px;
      font-size: 28px;
      font-weight: 400;
      color: #1a1c34;
      position: relative;
      .drawJt {
        position: absolute;
        right: 5%;
        top: 20%;
        border: 3px solid #c2c0c0;
        width: 10px;
        height: 10px;
        border-left-color: transparent;
        border-top-color: transparent;
        //下箭头
        transform: rotate(45deg);
      }
      .title-text {
        width: 174px;
        text-align: center;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .title-r {
      display: flex;
      align-items: center;
      .txt {
        font-size: 28px;
        font-weight: 400;
        color: #1a1c34;
        line-height: 40px;
      }
      .img {
        width: 42px;
        height: 42px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .time {
    margin: 0 34px 50px;
    display: flex;
    // justify-content: center;
    text-align: center;
    height: 134px;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    .item {
      box-sizing: border-box;
      position: relative;
      min-width: 104px;
      height: 100%;
      padding: 14px;
      border-radius: 8px;
      white-space: nowrap;
      &:not(:last-child) {
        margin-right: 32px;
      }
    }
    .item-t {
      font-size: 26px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      line-height: 36px;
    }
    .item-b {
      margin-top: 14px;
      font-size: 24px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
      line-height: 34px;
    }
    .active {
      background: #ff9614ff;
      .item-t,
      .item-b {
        color: #ffffffff;
      }

      &::after {
        content: "";
        position: absolute;
        bottom: 14px;
        left: 0;
        right: 0;
        margin: auto;
        width: 10px;
        height: 10px;
        background: #ffffff;
        border-radius: 50%;
      }
    }
  }
  .main {
    padding: 0 34px 30px;
    .item {
      display: flex;
      background: #ffffff;
      box-shadow: 0px 0px 32px 0px rgba(66, 114, 153, 0.1);
      border-radius: 16px;
      margin-bottom: 30px;
      .item-l {
        width: 84px;
        border-right: 1px solid rgba(0, 0, 0, 0.06);
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 36px;
        font-weight: 600;
        color: #151c39;
        line-height: 50px;
      }
      .item-c {
        flex: 1;
        .list {
          display: flex;
          &:not(:last-child) {
            border-bottom: 1px solid rgba(0, 0, 0, 0.06);
          }
          .list-l {
            flex: 1;
            flex-shrink: 0;
            padding: 14px 16px;
            box-sizing: border-box;
          }
          .list-r {
            flex: 1;
            flex-shrink: 0;
            padding: 14px 16px;
            box-sizing: border-box;
          }
          .list-l {
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 24px;
            font-weight: 400;
            color: #151c39;
            line-height: 34px;
            border-right: 1px solid rgba(0, 0, 0, 0.06);
          }
          .list-r {
            display: flex;
            text-align: center;
            justify-content: center;
            align-items: center;
            font-size: 24px;
            font-weight: 400;
            color: #151c39;
            line-height: 34px;
          }
        }
      }
      .item-r {
        width: 182px;
        border-left: 1px solid rgba(0, 0, 0, 0.06);
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        .btn {
          .btn-l {
            font-size: 28px;
            font-weight: 400;
            color: #a8a8a8;
            line-height: 40px;
          }
          .btn-r {
            .opera1 {
              width: 124px;
              background: linear-gradient(180deg, #ffc055 0%, #fe9514 100%);
              border-radius: 10px;
              font-size: 24px;
              font-weight: 500;
              color: #ffffff;
              line-height: 52px;
              margin: 0 auto;
              &.full {
                background: linear-gradient(180deg, #ededed 0%, #d8d8d8 100%);
                color: #a7a7a7;
              }
            }
            .opera2 {
              width: 124px;
              border: 2px solid #ff9614;
              border-radius: 10px;
              font-size: 28px;
              font-weight: bold;
              color: #ff9614;
              line-height: 48px;
              margin: 0 auto;
            }
            .opera3 {
              font-size: 24px;
              font-weight: bold;
              color: #ff9614;
              line-height: 52px;
            }
          }
        }
        .txt {
          margin-top: 8px;
          font-size: 20px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.5);
          line-height: 28px;
        }
      }
    }
    .Kindergartens {
      .item {
        display: flex;
        background: #ffffff;
        box-shadow: 0px 0px 32px 0px rgba(66, 114, 153, 0.1);
        border-radius: 16px;
        margin-bottom: 30px;
        .item-l {
          width: 84px;
          border-right: 1px solid rgba(0, 0, 0, 0.06);
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 36px;
          font-weight: 600;
          color: #151c39;
          line-height: 50px;
        }
        .item-c {
          flex: 1;
          .list {
            display: flex;
            &:not(:last-child) {
              border-bottom: 1px solid rgba(0, 0, 0, 0.06);
            }
            .list-l {
              flex: 1;
              flex-shrink: 0;
              padding: 14px 16px;
              box-sizing: border-box;
            }
            .list-c {
              flex: 1;
              flex-shrink: 0;
              padding: 14px 16px;
              box-sizing: border-box;
            }
            .list-l {
              text-align: center;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 24px;
              font-weight: 400;
              color: #151c39;
              line-height: 34px;
              border-right: 1px solid rgba(0, 0, 0, 0.06);
            }
            .list-c {
              display: flex;
              text-align: center;
              justify-content: center;
              align-items: center;
              font-size: 24px;
              font-weight: 400;
              color: #151c39;
              line-height: 34px;
            }
            .list-r {
              flex: 1;
              border-left: 1px solid rgba(0, 0, 0, 0.06);
              display: flex;
              justify-content: center;
              align-items: center;
              text-align: center;
              .btn {
                .btn-l {
                  font-size: 28px;
                  font-weight: 400;
                  color: #a8a8a8;
                  line-height: 40px;
                }
                .btn-r {
                  .opera1 {
                    width: 124px;
                    background: linear-gradient(
                      180deg,
                      #ffc055 0%,
                      #fe9514 100%
                    );
                    border-radius: 10px;
                    font-size: 24px;
                    font-weight: 500;
                    color: #ffffff;
                    line-height: 52px;
                    margin: 0 auto;
                    &.full {
                      background: linear-gradient(
                        180deg,
                        #ededed 0%,
                        #d8d8d8 100%
                      );
                      color: #a7a7a7;
                    }
                  }
                  .opera2 {
                    width: 124px;
                    border: 2px solid #ff9614;
                    border-radius: 10px;
                    font-size: 28px;
                    font-weight: bold;
                    color: #ff9614;
                    line-height: 48px;
                    margin: 0 auto;
                  }
                  .opera3 {
                    font-size: 24px;
                    font-weight: bold;
                    color: #ff9614;
                    line-height: 52px;
                  }
                }
              }
              .txt {
                margin-top: 8px;
                font-size: 20px;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.5);
                line-height: 28px;
              }
            }
          }
        }
      }
    }
  }
}
.evaluateDialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
  .dialogMain {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    white-space: nowrap;
    box-sizing: border-box;
    width: 656px;
    .mainBody {
      padding: 74px 34px 46px;
      border-radius: 16px;
      background: #fff;
      overflow: auto;
      max-height: calc(100vh - 286px);
      .mainTitle {
        font-size: 32px;
        // font-weight: bold;
        color: #333333;
        line-height: 44px;
      }
      .mainScore {
        display: flex;
        padding: 18px 14px 24px;
        white-space: nowrap;
        .rate {
          margin-right: 48px;
          text-align: center;
          .rateIcon {
            // width: 48px;
            height: 48px;
            margin-bottom: 12px;
            img {
              width: 48px;
              height: 48px;
              overflow: hidden;
              vertical-align: middle;
            }
          }
          .rateTxt {
            display: flex;
            justify-content: center;
            width: 48px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 32px;
          }
        }
      }
      .mainUpload {
        ::v-deep .van-uploader__upload {
          width: 140px;
          height: 140px;
        }
        ::v-deep .van-uploader__preview {
          border: 0;
          .van-uploader__preview-image {
            width: 140px;
            height: 140px;
          }
          .van-uploader__preview-delete {
            width: 28px;
            height: 28px;
            border-radius: 0 0 0 24px;
            .van-uploader__preview-delete-icon {
              position: absolute;
              top: -7px;
              right: -7px;
              display: block;
            }
          }
        }
        .txt {
          margin-top: 14px;
          font-size: 24px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.5);
          line-height: 34px;
        }
      }
      .mainInput {
        margin-top: 26px;
        ::v-deep .van-field {
          background: rgba(0, 0, 0, 0.05);
          border-radius: 16px;
          .van-field__word-limit {
            color: rgba(0, 0, 0, 0.25);
          }
        }
      }
      .submitBtn {
        margin-top: 90px;
        width: 100%;
        display: flex;
        justify-content: center;
        .btn {
          width: 550px;
          height: 66px;
          font-size: 28px;
          line-height: 66px;
          text-align: center;
          font-weight: bold;
          border-radius: 10px;
          color: #ffffff;
          background: linear-gradient(180deg, #ffc055 0%, #fe9514 100%);
          &.light {
          }
        }
      }
    }
    .mainClose {
      width: 76px;
      height: 76px;
      margin: 62px auto 0;
      > img {
        width: 76px;
        height: 76px;
      }
    }
  }
}
</style>
